<template>
	<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M15 2.72727C8.22196 2.72727 2.72727 8.22196 2.72727 15C2.72727 21.778 8.22196 27.2727 15 27.2727C21.778 27.2727 27.2727 21.778 27.2727 15C27.2727 8.22196 21.778 2.72727 15 2.72727ZM0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z"
			fill="#029F5B"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M14.9996 8.18137C11.234 8.18137 8.18137 11.234 8.18137 14.9996C8.18137 18.7651 11.234 21.8177 14.9996 21.8177C18.7651 21.8177 21.8177 18.7651 21.8177 14.9996C21.8177 11.234 18.7651 8.18137 14.9996 8.18137ZM5.4541 14.9996C5.4541 9.72775 9.72775 5.4541 14.9996 5.4541C20.2714 5.4541 24.545 9.72775 24.545 14.9996C24.545 20.2714 20.2714 24.545 14.9996 24.545C9.72775 24.545 5.4541 20.2714 5.4541 14.9996Z"
			fill="#029F5B"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M14.9996 13.636C14.2465 13.636 13.636 14.2465 13.636 14.9996C13.636 15.7527 14.2465 16.3632 14.9996 16.3632C15.7527 16.3632 16.3632 15.7527 16.3632 14.9996C16.3632 14.2465 15.7527 13.636 14.9996 13.636ZM10.9087 14.9996C10.9087 12.7403 12.7403 10.9087 14.9996 10.9087C17.2589 10.9087 19.0905 12.7403 19.0905 14.9996C19.0905 17.2589 17.2589 19.0905 14.9996 19.0905C12.7403 19.0905 10.9087 17.2589 10.9087 14.9996Z"
			fill="#029F5B"
		/>
	</svg>
</template>

<script>
export default {
	name: 'b-icon-target-circle',
	components: {},
	computed: {},
	props: {},
};
</script>

<style scoped lang="scss">
</style>

<docs>
    IconTargetCircle

    ```js
    <b-icon-target-circle />
    ```
</docs>
